import { render } from "./dropItem.vue?vue&type=template&id=3367b604&scoped=true"
import script from "./dropItem.vue?vue&type=script&lang=js"
export * from "./dropItem.vue?vue&type=script&lang=js"

import "./dropItem.vue?vue&type=style&index=0&id=3367b604&scoped=true&lang=scss"

import exportComponent from "D:\\SelfCode\\ktpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3367b604"]])

export default __exports__